import { render, staticRenderFns } from "./promotionList.vue?vue&type=template&id=5b2eb823&lang=html"
import script from "./promotionList.vue?vue&type=script&lang=js"
export * from "./promotionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports